import omit from 'lodash-es/omit';
import { BusinessPartnerListCommonExportProcessor } from './business-partner-list-common';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';

export class BusinessPartnerListJsonExportProcessor extends BusinessPartnerListCommonExportProcessor {
  constructor() {
    super();
  }

  protected override transformForMainSection(item: BusinessPartnerAttributes) {
    return {
      ...super.transformForMainSection(item),
      details: super.transformForPriceListSection(item).map((data) => omit(data, 'externalKeys', 'name')),
    }
  }

  override onAddData(item: BusinessPartnerAttributes) {
    this.addToSection('distributionChains', this.transformForMainSection(item));
  }
}